import React from 'react';
import { Link } from 'react-router-dom';
import { IconArrowLeftFill } from '@saucelabs/ds-icons';

export const BackToPlatformSpan: React.FC = () => (
  <span
    className="text-blue-700 text-base font-semibold"
  >
    <IconArrowLeftFill className="fill-current w-2 h-2 align-middle mr-1" />
    Back to Platform
  </span>
);

const BackToPlatformLink: React.FC = () => (
  <Link to="/">
    <BackToPlatformSpan />
  </Link>
);

export default BackToPlatformLink;
